import React from "react";

import Loader from "./Loader";

type IntialLoadingPageProps = {
  /** Optional message describing what is loading. Announced to screen readers. */
  message?: string;
};

const IntialLoadingPage: React.FC<IntialLoadingPageProps> = ({
  message = "Loading…",
}) => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex h-screen w-screen flex-col items-center justify-center gap-3 bg-white"
    >
      <Loader />
      <span className="text-sm text-text-secondary">{message}</span>
    </div>
  );
};

export default IntialLoadingPage;
